<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">{{ this.queryParams.varieties }}</span> > 大数据价格预测</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>{{ this.queryParams['varieties'] }}价格预测</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" type="text" placeholder="请输入关键词">
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item)">{{ item.showYearTime + queryParams['varieties'] + '价格预测' }}</p>
          <span class="fr">{{ item.dateNow }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams['pageSize']"
          :current-page="queryParams['pageNum']"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  caprolactamForecastList
} from '@/api'

export default {
  data() {
    return {
      list: [],
      total: 0,
      backUrl: '/coke',
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        varieties: '',
      }
    }
  },
  created() {
    this.backUrl = JSON.parse(this.$route.query.flag).url
    this.queryParams['varieties'] = JSON.parse(this.$route.query.flag).varieties
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      caprolactamForecastList(this.queryParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 详情
     */
    goDetail(row) {
      this.$router.push({
        path: `${this.backUrl}/forecast`,
        query: {id: row.id, flag: this.backUrl, other: this.queryParams['varieties']}
      })
    },
    /**
     * 回退
     */
    back() {
      this.$router.push(this.backUrl)
    },
    /**
     * 搜索
     */
    search() {
      this.getList()
    },

    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
